export enum ShapeTypeEnum {
    line = 0,
    polygon = 1,
  }
